import {
  createSmtpIntegrationAsync,
  deleteSmtpIntegrationAsync,
  getAllSmtpIntegrationsAsync,
  getSmtpIntegrationByIdAsync,
  updateSmtpIntegrationAsync,
  changeSmtpPasswordAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSmtpIntegrationAsync = () =>
  useMutation(createSmtpIntegrationAsync);

export const useGetSmtpIntegrationByIdAsync = () =>
  useMutation(getSmtpIntegrationByIdAsync);

export const useGetAllSmtpIntegrationsAsync = () =>
  useMutation(getAllSmtpIntegrationsAsync);

export const useUpdateSmtpIntegrationAsync = () =>
  useMutation(updateSmtpIntegrationAsync);

export const useDeleteSmtpIntegrationAsync = () =>
  useMutation(deleteSmtpIntegrationAsync);

export const useChangeSmtpPasswordAsync = () =>
  useMutation(changeSmtpPasswordAsync);
